// Module
var code = "<div class=\"conditions\"> <div class=\"links disclaimer\"> <div class=\"lawcompliance\"> <p ng-if=\"!modalclosable\" ng-bind-html=\"messages.PrivacyPolicyDisclaimerText\"></p> <p ng-if=\"modalclosable\" ng-bind-html=\"messages.PrivacyPolicyDisclaimerTextWithCloseBtn\"></p> </div> </div> </div> ";
// Exports
module.exports = code;